import React, { Fragment, useEffect, useState } from 'react';
import Sidebar from './Sidebar';
import Watch from './Watch';
import { IMAGES } from '../../../constants';
import ProtectedHeader from '../../layout/ProtectedHeader';
import MetaData from '../../layout/MetaData';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import { getAllProducts } from '../../../actions/productActions';
import { getLastURL } from '../../../helper';
import mixpanel from 'mixpanel-browser';
import { FormattedMessage } from 'react-intl';

const Index = () => {

    const dispatch = useDispatch();
    const location = useLocation();

    const pathname = getLastURL(location);
    const [pageReset, setPageReset] = useState(0);
    const [showFilters, setShowFilters] = useState(false);


    useEffect(() => {
        dispatch(getAllProducts(pathname));
    }, [dispatch])


    const tabChangeHandler = () => {
        setPageReset(0)
    }

    const updateResetPageHandler = (i) => {
        setPageReset(i);
    }

    useEffect(() => {
        mixpanel.track('Find Watches Jan25')
    }, [])



    return (
        <Fragment>
            <MetaData title={`Watch`} />
            <ProtectedHeader />
            <ul className="breadcrub">
                <li><FormattedMessage id="AllCategories" defaultMessage="All Categories" /></li>
                <li><img src={IMAGES.ARROW_SVG} alt="" /></li>
                <li><FormattedMessage id="category.watches" defaultMessage="Watches" /></li>
                <li><img src={IMAGES.ARROW_SVG} alt="" /></li>
                <li><FormattedMessage id="SearchResults" defaultMessage="Search results" /> </li>
            </ul>
            <main className="sp-inner-page-body sp_dashboard">
                <section className="sp-order-req-sec">
                    <div className="container-fluid">
                        <span className="menu-btn">
                            <i className="icon-more-options" aria-hidden="true"></i>
                        </span>
                            <div className="row">
                                <div className={'side-filter-overlay' + (showFilters ? " show" : "")} onClick={() => setShowFilters(false)}></div>
                                <div className={'side-filter' + (showFilters ? " open" : "")}>
                                    <div className='side-filter-inner '>
                                        <button
                                            className='close-filter'
                                            id="close-side-filter"
                                            onClick={() => setShowFilters(false)}
                                        >&times;</button>
                                        <div className='row'>
                                            <Sidebar tabChangeHandler={tabChangeHandler} setShowFilters={setShowFilters} />
                                        </div>
                                    </div>
                                </div>
                                <Watch setShowFilters={setShowFilters} showFilters={showFilters} updateResetPageHandler={updateResetPageHandler} pageReset={pageReset} tabChangeHandler={tabChangeHandler} />
                            </div>
                        <div className="dashboard-sec">
                        </div>
                    </div>
                </section>
            </main>
        </Fragment>
    )
}

export default Index
